import React from 'react';

import NarrativeChapter from './NarrativeChapter';

/**
 * Renders the shared-language typographic bridge. Accepts no props.
 *
 * @returns {React.ReactElement} Chapter six with approved copy and decorative
 *   language labels.
 * @sideEffects Has no external side effects beyond React rendering.
 */
export default function LanguageBridge({ index = 7 }) {
  return (
    <NarrativeChapter
      index={index}
      id="language"
      title="Before chemistry, conversation."
      body="Milan only introduces people who share at least one language, so a real conversation can begin."
    >
      <div className="language-bridge" aria-hidden="true">
        <span>English</span>
        <span>Español</span>
        <span>हिन्दी</span>
        <span>தமிழ்</span>
        <span>中文</span>
        <span>Français</span>
        <span>日本語</span>
        <span>Deutsch</span>
        <span>Português</span>
      </div>
    </NarrativeChapter>
  );
}
